<iframe *ngIf="url" [src]="url" frameborder="0" width="100%" height="850" title="extViewFrame" ></iframe>



// WEBPACK FOOTER //
// ./src/app/views/external-view/external-view.component.html